var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestrictedAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 52,
    viewBox: "0 0 43 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7647_9338)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.02648 11.3427V22.612C4.02648 33.0957 10.6655 42.5246 21.0085 46.8344C31.3515 42.5246 37.9899 33.0957 37.9899 22.612V11.3427C31.8024 10.9591 25.8841 8.81321 21.0085 5.18102C16.1323 8.81321 10.2145 10.9591 4.02648 11.3427V11.3427ZM21.0085 51.1624L20.2819 50.8814C7.96111 46.1118 0 35.0154 0 22.612V7.37871H2.013C8.54498 7.37871 14.8336 5.13901 19.7205 1.07197L21.0085 0L22.2964 1.07197C27.1833 5.13901 33.4719 7.37871 40.0034 7.37871H42.0164V22.612C42.0164 35.0154 34.0558 46.1118 21.735 50.8814L21.0085 51.1624Z",
    fill: "#B0DEEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0078 46.8343C31.3508 42.5249 37.9898 33.0961 37.9898 22.6124V11.3425C31.8018 10.959 25.884 8.81358 21.0078 5.1809V0.000366211L22.2957 1.07185C27.1826 5.13888 33.4713 7.37859 40.0033 7.37859H42.0163V22.6124C42.0163 35.0158 34.0552 46.1117 21.7343 50.8813L21.0078 51.1622V46.8343Z",
    fill: "#0080A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01367 9.39163C9.32154 9.39163 15.9649 6.81626 21.0086 2.61926C26.0519 6.81626 32.6958 9.39163 40.0036 9.39163V22.6124C40.0036 34.5209 32.1539 44.6894 21.0086 49.0037C9.86289 44.6894 2.01367 34.5209 2.01367 22.6124V9.39163",
    fill: "#F2F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0088 2.61914C26.052 6.81663 32.6959 9.39151 40.0038 9.39151V22.6123C40.0038 34.5207 32.1545 44.6893 21.0088 49.0041V2.61914Z",
    fill: "#D9E3E7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7647_9338)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6854 36.925H14.3327C13.3574 36.925 12.5674 36.1345 12.5674 35.1593V23.9168C12.5674 22.9415 13.3574 22.151 14.3327 22.151H27.6854C28.6606 22.151 29.4512 22.9415 29.4512 23.9168V35.1593C29.4512 36.1345 28.6606 36.925 27.6854 36.925",
    fill: "#877502"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.788 19.5037C16.788 17.176 18.6817 15.2822 21.0094 15.2822C23.3366 15.2822 25.2298 17.176 25.2298 19.5037V25.8353H27.341V19.5037C27.341 16.0068 24.5062 13.172 21.0094 13.172C17.5121 13.172 14.6777 16.0068 14.6777 19.5037V25.8353H16.788V19.5037",
    fill: "#19566A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6854 36.3882H14.3327C13.3574 36.3882 12.5674 35.5976 12.5674 34.6224V23.3799C12.5674 22.4047 13.3574 21.6141 14.3327 21.6141H27.6854C28.6606 21.6141 29.4512 22.4047 29.4512 23.3799V34.6224C29.4512 35.5976 28.6606 36.3882 27.6854 36.3882",
    fill: "#ECD444"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1194 27.9457C23.1194 26.7799 22.1744 25.8354 21.0092 25.8354C19.8434 25.8354 18.8984 26.7799 18.8984 27.9457C18.8984 28.7269 19.323 29.4066 19.9538 29.7715V32.1671H22.0645V29.7715C22.6943 29.4066 23.1194 28.7269 23.1194 27.9457",
    fill: "#877502"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7647_9338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.0189,
    height: 51.7907,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7647_9338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5893,
    height: 24.4296,
    fill: "white",
    transform: "translate(12.5674 13.172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedAccess);
export default __webpack_public_path__ + "static/media/RestrictedAccess.e77a8d87140599c1a54bc984d6de5c86.svg";
export { ForwardRef as ReactComponent };